import { memo } from 'react';
import { Empty, Spin, Table, Tag } from 'antd';
import moment from 'moment';
import ExportExcel from '../../commonComponents/Export-Excel';

const BAY_TYPE_COLORS = {
    apparel: 'magenta',
    product: 'blue',
    scanning: 'cyan',
};

function formatBayType(type) {
    if (!type) return '';
    return type.charAt(0).toUpperCase() + type.slice(1);
}

function formatScanTime(value) {
    if (!value) return '';
    const local = moment.utc(value).local();
    if (!local.isValid() || local.year() === 1970) return '';
    return local.format('YYYY-MM-DD HH:mm:ss');
}

function timeToFirstScan(start, first) {
    if (!start || !first) return '';
    const startAt = new Date(start);
    const firstAt = new Date(first);
    if (Number.isNaN(+startAt) || Number.isNaN(+firstAt) || startAt.getFullYear() <= 1971 || firstAt.getFullYear() <= 1971) return '';
    const sign = firstAt < startAt ? '-' : '';
    const totalMinutes = Math.round(Math.abs(firstAt - startAt) / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours) return `${sign}${hours}h ${minutes}m`;
    return `${sign}${minutes}m`;
}

function excelRows(rows) {
    return (rows || []).map(row => ({
        Designation: row.designation || '',
        Name: row.name || '',
        Email: row.email || '',
        'Bay Email': row.bayEmail || '',
        'Bay type': formatBayType(row.bayType),
        Date: row.date || '',
        'Start time': formatScanTime(row.startTime),
        'End Time': formatScanTime(row.endTime),
        'First scan time': formatScanTime(row.firstScanTime),
        'Time to First scan': timeToFirstScan(row.startTime, row.firstScanTime),
        'Last scan time': formatScanTime(row.lastScanTime),
    }));
}

function timeCell(value) {
    const text = formatScanTime(value);
    return text || <span className="count-zero">—</span>;
}

const columns = [
    { title: 'Designation', dataIndex: 'designation', width: 140, render: value => value || '—' },
    { title: 'Name', dataIndex: 'name', width: 160, render: value => value || '—' },
    { title: 'Email', dataIndex: 'email', width: 220, render: value => value || '—' },
    { title: 'Bay Email', dataIndex: 'bayEmail', width: 220, render: value => value || '—' },
    {
        title: 'Bay type',
        dataIndex: 'bayType',
        width: 110,
        render: type => {
            const label = formatBayType(type);
            if (!label) return '—';
            return <Tag color={BAY_TYPE_COLORS[type] || 'default'}>{label}</Tag>;
        },
    },
    { title: 'Date', dataIndex: 'date', width: 120, render: value => value || '—' },
    { title: 'Start time', dataIndex: 'startTime', width: 170, render: timeCell },
    { title: 'End Time', dataIndex: 'endTime', width: 170, render: timeCell },
    { title: 'First scan time', dataIndex: 'firstScanTime', width: 170, render: timeCell },
    {
        title: 'Time to First scan',
        key: 'timeToFirstScan',
        width: 150,
        render: (_, row) => timeToFirstScan(row.startTime, row.firstScanTime) || <span className="count-zero">—</span>,
    },
    { title: 'Last scan time', dataIndex: 'lastScanTime', width: 170, render: timeCell },
];

function BayTeamsModal({ loading, rows, dateLabel }) {
    const list = rows || [];
    return (
        <div className="bay-teams-modal">
            <div className="bay-teams-modal-bar">
                <span>
                    {list.length} {list.length === 1 ? 'person' : 'people'} on {dateLabel}
                </span>
                {list.length > 0 && (
                    <ExportExcel
                        buttonSize="middle"
                        buttonText="Export Excel"
                        excelData={excelRows(list)}
                        fileName={`bay-teams-${(dateLabel || 'today').replace(/\s+/g, '-')}`}
                    />
                )}
            </div>
            {loading ? (
                <div className="qc-modal-loading">
                    <Spin />
                </div>
            ) : (
                <Table
                    size="small"
                    bordered
                    columns={columns}
                    dataSource={list}
                    rowKey={(row, index) => `${row.bayEmail}-${row.email}-${row.designation}-${index}`}
                    pagination={list.length > 50 ? { pageSize: 50, showSizeChanger: false } : false}
                    scroll={{ x: 1760 }}
                    locale={{ emptyText: <Empty description={`No teams for ${dateLabel}`} /> }}
                />
            )}
        </div>
    );
}

export default memo(BayTeamsModal);
